import { useCallback } from "react";
import { REDIRECT_URL_PARAM, ROUTES } from "@nf/constants";
import { useRedirectUrlParam } from "./useRedirectUrlParam";
import { useRouter } from "./useRouter";

export const useRedirectToProfileScreen = () => {
  const router = useRouter();
  const redirectUrl = useRedirectUrlParam();

  return useCallback(() => {
    const url = redirectUrl
      ? {
          pathname: ROUTES.SELECT_PROFILE_SCREEN,
          query: {
            [REDIRECT_URL_PARAM]: redirectUrl,
          },
        }
      : { pathname: ROUTES.SELECT_PROFILE_SCREEN };

    router.replace(url);
  }, [redirectUrl]);
};
